<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.goods_label_orderGoodsNo') || '订单产品'"
            prop="orderGoodsNo"
          >
            <el-input
              clearable
              v-model="formData.orderGoodsNo"
              readonly
              size="small"
              :placeholder="
                $l('INDEX.tips_goods_label_orderGoodsNo') || '请选择订单产品'
              "
            >
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="() => (visible = true)"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item
            :label="$l('INDEX.goods_label_qty') || '数量'"
            prop="qty"
          >
            <el-input-number
              style="width: 100%"
              clearable
              v-model="formData.qty"
              :step="1"
              :precision="0"
              :min="0"
              :max="9999999"
              controls-position="right"
              :placeholder="$l('INDEX.tips_goods_label_qty') || '请输入数量'"
              size="small"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button @click="close()" size="small">{{
          $l('INDEX.btn_no_save') || '不保存'
        }}</el-button>
        <el-button @click="save()" type="primary" size="small">{{
          $l('INDEX.btn_save') || '保存'
        }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-if="visible"
      :visible.sync="visible"
      append-to-body
      show-close
      width="1000px"
      :title="$l('INDEX.dialog_title_choose_order_goods') || '添加订单产品'"
      :close-on-click-modal="false"
      :before-close="() => goodsDialogClose()"
    >
      <goods-table
        :changeOrderCode="changeOrderCode"
        ref="goods"
        :isCheckBox="isCheckBox"
      />
      <span slot="footer">
        <el-button size="small" @click="goodsDialogClose()">{{
          $l('INDEX.btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.btn_confirm') || '确认'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import GoodsTable from './goods-table/index.vue'

export default {
  components: {
    GoodsTable,
  },
  props: {
    disabled: Boolean,
    code: String,
    changeOrderCode: String,
    orderBatchCode: String,
    isAdd: Boolean,
    isCheckBox: { type: Boolean, default: false },
  },
  data() {
    return {
      backDialogVisible: false,
      visible: false,
      formData: {
        orderGoodsCode: '',
        orderGoodsNo: '',
        orderGoodsCodeList: [], //做批量添加的集合属性
      },
      rules: {
        orderGoodsNo: [
          {
            required: true,
            message:
              this.$l('INDEX.tips_goods_label_orderGoodsNo') ||
              '请选择订单产品',
            trigger: 'change',
          },
        ],
        qty: [
          {
            required: true,
            message: this.$l('INDEX.tips_goods_label_qty') || '请输入数量',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
    //console.log(this.changeOrderCode)
  },
  methods: {
    getData() {
      if (!this.code) return
      this.$api
        .orderBatchGoodsDetailApi({
          orderBatchGoodsCode: this.code,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return (this.backDialogVisible = false)
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      //根据是否添加操作调用不同接口
      if (this.isAdd) {
        if (this.isCheckBox) {
          //如果是批量操作，则调用不同的接口
          this.$api
            .orderBatchGoodsAddListApi({
              ...this.formData,
              changeOrderCode: this.changeOrderCode,
              orderBatchCode: this.orderBatchCode,
            })
            .then((res) => {
              loadingInstance.close()
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || res.msg,
                type: 'success',
              })
              this.$emit('close')
              this.$emit('reload')
            })
            .catch(() => {
              loadingInstance.close()
            })
        } else {
          this.$api
            .orderBatchGoodsAddApi({
              ...this.formData,
              changeOrderCode: this.changeOrderCode,
              orderBatchCode: this.orderBatchCode,
            })
            .then((res) => {
              loadingInstance.close()
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || res.msg,
                type: 'success',
              })
              this.$emit('close')
              this.$emit('reload')
            })
            .catch(() => {
              loadingInstance.close()
            })
        }
      } else {
        this.$api
          .orderBatchGoodsModiApi({
            ...this.formData,
            changeOrderCode: this.changeOrderCode,
            orderBatchCode: this.orderBatchCode,
          })
          .then((res) => {
            loadingInstance.close()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || res.msg,
              type: 'success',
            })
            this.$emit('close')
            this.$emit('reload')
          })
          .catch(() => {
            loadingInstance.close()
          })
      }
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },

    goodsDialogClose() {
      this.visible = false
    },

    confirm() {
      let orderGoodsData = this.$refs.goods.getRadioRecord()
      this.formData.orderGoodsNo = ''
      this.formData.orderGoodsCodeList = []
      if (orderGoodsData) {
        if (this.isCheckBox) {
          orderGoodsData.forEach((item) => {
            this.formData.orderGoodsCodeList.push(item.orderGoodsCode)
            this.formData.orderGoodsNo += '-' + item.orderGoodsNo
          })
          this.formData.orderGoodsNo = this.formData.orderGoodsNo.substring(1)
        } else {
          this.formData.orderGoodsCode = orderGoodsData.orderGoodsCode
          this.formData.orderGoodsNo = orderGoodsData.orderGoodsNo
        }
        this.goodsDialogClose()
      }
    },
  },
}
</script>
